import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-type-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-type-form.component.html',
    styleUrls: ['./free-form-type-form.component.scss'],
    standalone: false
})
export class FreeFormTypeFormComponent {
  #isSubmitted = signal(false);
  #freeForm: FlatModels.AnnotationEntityModels.FreeForm;
  freeFormTypeForm = new FormGroup(
    {
      shape: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.AnnotationEntityModels.FreeFormSchema.pick({
          shape: true
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((freeForm) => {
      this.#freeForm = structuredClone(freeForm) as FlatModels.AnnotationEntityModels.FreeForm;
      if (freeForm) {
        this.freeFormTypeForm.reset(this.#freeForm);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.freeFormTypeForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeForm = assign(this.#freeForm, this.freeFormTypeForm.value);
    this.slideAuthorFacade.requestUpdateAnnotation(freeForm, 'history.free_form_update_type').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.freeFormTypeForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
